<template>
	<div id="partners">
		<div :class="['partner', {'reverse': i%2}]" v-for="(p,i) in partners" :key="i">
			<VideoSwiper theme="blue" :videos="videos" style="background-color: #FBFBFB;"></VideoSwiper>
			<div class="content">
				<div class="title">{{p.title}}</div>
				<div class="sub-title">{{p.subTitle}}</div>
				<div class="cards">
					<div class="card" v-for="(c,k) in p.cards" :key="k">
						<img class="icon" :src="c.icon" />
						<div class="name">{{c.name}}</div>
						<div class="desc">{{c.desc}}</div>
					</div>
				</div>
				<a :href="p.btnLink">
					<div class="link-button">{{p.btnName}}</div>
				</a>
			</div>
		</div>
	</div>
</template>

<script>
	import VideoSwiper from './VideoSwiper.vue'
	export default {
		components: {
			VideoSwiper
		},
		data() {
			return {
				swiperOptions: {
					pagination: {
						el: '.swiper-pagination'
					},
					loop: true
				},
				videos: [
          'https://prod-webuysg.oss.webuy.ren/video/partner1.mp4',
          'https://prod-webuysg.oss.webuy.ren/video/partner2.mp4',
					// 'https://prod-cdn-byteplus-video.webuy.ren/video/tos/sgcomm1/tos-sgcomm1-v-650ef2-sg/66a7289f6ea7462aaa7134227b7d6dfc/?Expires=1632618648&Key-Pair-Id=KB4PN0TUK59ZL&Signature=BT5oIKna~7dk94qbLKgdzkFipdeiULW9XPlybiPsdroobx~mEwjOYNX7lXckAXUXWZqCwxreCuhmeujXJrIry928so6zfSpcwAuMKsRD~UhGN-IkpkYi5CxAZyZHguVj3ql6JDJg2kM-yDTdo~qK9KkUWhGK8U4E6Y1UMI1z6lMFsSxQEuipZAj7abbhU7ar3SOkDez78katXPtIWD3KHOSmj84CyxauNpPQA3LVatZlOC17Mn23HzfiMIoxTZRAoi6LD0S6LbIzF07dzCri00LhGsgXjQac62wgqPWfAyAd1eIa7vriN1PmopnlokDgkSxdySHfopKu~MFPWCdJWQ__',
				],
				partners: [{
					title: 'PARTNERS',
					subTitle: 'My most fulfilling journey yet',
					cards: [{
						icon: require('../../assets/piggy-bank.png'),
						name: 'Incentives',
						desc: 'Earn incentives from every group buy hosting!'
					}, {
						icon: require('../../assets/love.png'),
						name: 'Guidance & Sharing',
						desc: 'Our experienced group leaders will be happy to help you in your group leader journey!'
					}],
					btnName: 'Join as a Partner',
					btnLink: 'https://www.webuy.longtongjiyun.com/groupleader'
				}],
			}
		},
		computed: {
			swiper() {
				return this.$refs.mySwiper.swiper
			}
		},
		mounted() {

		},
		methods: {
			slidePrev() {
				this.swiper.slidePrev()
			},
			slideNext() {
				this.swiper.slideNext()
			}
		}
	}
</script>

<style lang="scss" scoped>
	#partners {
		&::before {
			content: '';
			display: block;
			height: 64px;
			margin-top: -64px;
			visibility: hidden;
		}

		.partner {
			width: 1040px;
			margin: 0 auto;
			height: 600px;
			display: flex;
			margin-bottom: 60px;

			&.reverse {
				flex-flow: row-reverse;
			}

			.content {
				width: 50%;
				padding: 40px;
				box-sizing: border-box;

				.title {
					font-weight: 600;
					font-size: 20px;
					line-height: 30px;
					letter-spacing: 4px;
					color: #02283F;
				}

				.sub-title {
					font-weight: bold;
					font-size: 32px;
					line-height: 48px;
					color: #0060FF;
					margin: 40px 0;
				}

				.cards {
					display: flex;
					justify-content: space-between;

					.card {
						width: 200px;

						.icon {
							width: 40px;
							height: 40px;
						}

						.name {
							font-weight: 600;
							font-size: 24px;
							line-height: 32px;
							color: #02283F;
							margin: 10px 0;
						}

						.desc {
							font-weight: 500;
							font-size: 14px;
							line-height: 21px;
							color: #5C5C5C;
						}
					}
				}

				a {
					text-decoration: none;
				}

				.link-button {
					width: 200px;
					height: 40px;
					background: #0060FF;
					border-radius: 14px;
					margin-top: 40px;
					font-weight: 500;
					font-size: 14px;
					line-height: 40px;
					color: #fff;
					text-align: center;
				}
			}
		}

		.brand {
			width: 1040px;
			margin: 0 auto;

			.brand-logos {
				display: flex;
				align-items: center;
				justify-content: space-between;
				margin-bottom: 60px;

				img {
					width: 130px;
					height: 130px;

					&.brand3 {
						width: 160px;
						height: 90px;
					}
				}
			}

			.brand-swiper {
				display: flex;
				align-items: center;
				justify-content: space-between;

				.left-button {
					width: 26px;
				}

				.swiper {
					.swiper-item {
						display: flex;
						justify-content: center;

						.card {
							width: 400px;
							height: 232px;
							background: #FBFBFB;
							box-sizing: border-box;
							padding: 16px 36px;
							margin-right: 20px;

							.logo {
								width: 60px;
								height: 60px;
							}

							.title {
								font-weight: bold;
								font-size: 32px;
								line-height: 48px;
								color: #5C5C5C;
							}

							.content {
								font-weight: 500;
								font-size: 14px;
								line-height: 21px;
								color: #02283F;
							}

							.user {
								font-weight: normal;
								font-size: 12px;
								line-height: 18px;
								color: #5C5C5C;
							}
						}
					}
				}

				.left-button {
					cursor: pointer;
				}

				.right-button {
					width: 26px;
					cursor: pointer;
				}
			}
		}

		.investors {
			height: 200px;
			background: #FBFBFB;
			padding-top: 30px;

			.content {
				width: 1040px;
				margin: 0 auto;
			}

			.title {
				font-weight: 600;
				font-size: 20px;
				line-height: 30px;
				text-align: center;
				letter-spacing: 4px;
				color: #02283F;
				margin: 30px 0;
			}

			.pics {
				height: 100px;
				display: flex;
				align-items: center;
				justify-content: space-between;

				.pic {}

				.in1 {
					width: 79px;
					height: 60px;
				}

				.in2 {
					width: 174px;
					height: 47px;
				}

				.in3 {
					width: 246px;
					height: 25px;
				}

				.in4 {
					width: 193px;
					height: 38px;
				}
			}
		}
	}
</style>
